import React, { Component } from 'react'
import { Col, Row } from '@sketchpixy/rubix'
import { Field, reduxForm, SubmissionError } from 'redux-form'
import { browserHistory } from 'react-router'
import { connect } from 'react-redux'
import { appendToFormData } from '../../helpers/utility'
import { PASSWORD_CHANGE_REQUEST } from '../../actions/actions'
import * as MabnaButton from "../common/Button/Button";

const styles = {
  formRow: {
    marginRight: 0,
    width: '100%'
  }
}

class PasswordChange extends Component {
  currentPassword = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <Row className="form-row" style={styles.formRow}>
        <Col>
          <label htmlFor="password">گذرواژه فعلی</label>
        </Col>

        <Col>
          <input
            type="password"
            name="password"
            id="password"
            placeholder="گذرواژه فعلی"
            {...input}
            {...custom}
          />
        </Col>
        <div className="form-error">{hasError && error}</div>
      </Row>
    )
  }

  newPassword = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined

    return (
      <Row className="form-row" style={styles.formRow}>
        <Col>
          <label htmlFor="newPassword">گذرواژه جدید</label>
        </Col>

        <Col>
          <input
            type="password"
            name="newPassword"
            id="newPassword"
            placeholder="گذرواژه جدید"
            {...input}
            {...custom}
          />
        </Col>
        <div className="form-error">{hasError && error}</div>
      </Row>
    )
  }

  confirmNewPassword = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <Row className="form-row" style={styles.formRow}>
        <Col>
          <label htmlFor="confirmNewPassword">تایید گذرواژه جدید</label>
        </Col>

        <Col>
          <input
            type="password"
            name="confirmNewPassword"
            id="confirmNewPassword"
            placeholder="تایید گذرواژه جدید"
            {...input}
            {...custom}
          />
        </Col>
        <div className="form-error">{hasError && error}</div>
      </Row>
    )
  }

  handleSubmit = values => {
    const formData = appendToFormData(values)

    return new Promise((resolve, reject) => {
      this.props.dispatch({
        type: PASSWORD_CHANGE_REQUEST,
        formData,
        resolve,
        reject
      })
    })
      .then(() => this.redirect())
      .catch(response => {
        throw new SubmissionError({
          _error: response.general_errors[0],
          ...response.form_errors
        })
      })
  }

  redirect = () => browserHistory.push('/dashboard/profile')

  render() {
    const { handleSubmit, error } = this.props
    return (
      <div className="profile-page-user-forms">
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <Field name="current_password" component={this.currentPassword} />
          <Field name="new_password" component={this.newPassword} />
          <Field name="confirm_password" component={this.confirmNewPassword} />
          <Row className="form-row">{error && <strong>{error}</strong>}</Row>
          <Row className="form-row">
            <MabnaButton.Primary type="submit">
              {this.props.minorAsyncCall ? '...' : 'ذخیره'}
            </MabnaButton.Primary>
          </Row>
        </form>
      </div>
    )
  }
}

function validate(values) {
  let errors = {}
  if (!values.current_password) {
    errors.current_password = 'گذرواژه نباید خالی باشد'
  }

  if (!values.new_password) {
    errors.new_password = 'گذرواژه جدید نباید خالی باشد'
  }

  if (!values.confirm_password) {
    errors.confirm_password = 'تایید گذرواژه نباید خالی باشد'
  }

  if (values.confirm_password !== values.new_password) {
    errors.confirm_password = 'تایید گذرواژه باید یکسان باشند'
  }

  return errors
}

PasswordChange = reduxForm({
  form: 'PasswordChange',
  validate,
  fields: ['new_password', 'confirm_password', 'current_password']
})(PasswordChange)

export default connect(state => state.profile.minorAsyncCall)(PasswordChange)



// WEBPACK FOOTER //
// ./src/components/dashboard/PasswordChange.js